import React from 'react';

import { Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';

export const CopyMachineryUsesIchiPlusWarning = ({
  dialog: { message, callback },
}) => {
  return (
    <Information
      visible={true}
      title={messageUtility.getMessage('I-001-507')}
      message={message}
      buttonClassName='btn'
      buttonText='はい'
      onClose={callback.close}
      multilineText={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/MachineryUsesDialog.jsx